import { render } from "./DNComponentCreateForm.vue?vue&type=template&id=a095a9a4"
import script from "./DNComponentCreateForm.vue?vue&type=script&lang=js"
export * from "./DNComponentCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/abiinteriors/Documents/WorkSpace/abi-content-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__